module.exports = __webpack_public_path__ + "fonts/nunitosans-bold-webfont.b11f8aa.woff";